"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationType = void 0;
var DurationType;
(function (DurationType) {
    // cannot be removed by any means
    DurationType[DurationType["Instant"] = 0] = "Instant";
    // lasts for a number of turns or until the target dies
    DurationType[DurationType["Turns"] = 1] = "Turns";
    // lasts forever
    DurationType[DurationType["Permanent"] = 3] = "Permanent";
    // lasts for a number of ticks or until the target dies
    DurationType[DurationType["Ticks"] = 4] = "Ticks";
    // lasts until the end of the current turn
    DurationType[DurationType["EndOfTurn"] = 5] = "EndOfTurn";
})(DurationType = exports.DurationType || (exports.DurationType = {}));
